// Copyright © 2021 Move Closer
import { TileSize } from './Tile.contracts';
/**
 * Registry that binds the `TileSize` with the applicable CSS class.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const tileSizeClassRegistry = {
    [TileSize.XL]: '--size-xl',
    [TileSize.L]: '--size-l',
    [TileSize.S]: '--size-s'
};
